module.exports = __webpack_public_path__ + "static/media/dpl3.png.32e00aa4.jpg";